import React, { useState, useContext } from "react";
import ModalCustom from "../../../components/ModelCustomComponent";
import mainContext from "../context/MainContext/mainContext";
import FileInput from "./FileInput";
import FileInputWithHistoryView from "./FileInputWithHistoryView";
import handleDownloadExcel from "../utils/handleDownloadExcel";
import generatePresentation from "../utils/generatePresentation";
import { FaInbox } from "react-icons/fa";
import { Spin } from "antd";

const TabContent1 = ({ proposals, accepted, downloadAllowed, loading }) => {
  const {
    setActiveTab,
    inventories, //🌟
    setInventories, //🌟
    selectedInv,
    setSelectedInv,
    proposalId,
    setProposalId, //🌟
    fetchProp, //🌟
    setFetchProp, //🌟
    setShowLoader,
    apiBaseUrl,
  } = useContext(mainContext);
  const [isOpen, setIsOpen] = useState({});
  const [ok, setOk] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [PR, setPR] = useState(null); //this is Package Rate ..not Pull Request though 🤡🤡
  const [editProposal, setEditProposal] = useState(false); //This distinguishes if we are editing or viewing the proposal

  const [excelURL, setExcelURL] = useState(null);
  const [pptURL, setPptURL] = useState(null);

  const toggleList = (ele) => {
    setIsOpen((prevState) => ({
      ...prevState,
      [ele]: !prevState[ele],
    }));
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <Spin spinning={loading} size="large" />
      </div>
    );
  }

  return (
    <div className="proposal-tab-list">
      <div className="proposal-list-container">
        {proposals?.map((ele, ind) => {
          if (ele?.generatedProps?.length > 1) {
            return (
              <div
                key={ind}
                className={`fileList ${isOpen[ind] ? "showing" : "closed"}`}
              >
                {ele?.generatedProps.map((elem, index) => {
                  if (index == 0) {
                    return (
                      <FileInputWithHistoryView
                        toggleList={toggleList}
                        isOpen={isOpen}
                        ind={ind}
                        data={elem}
                        length={ele.generatedProps?.length}
                        index={index}
                        setOk={setOk}
                        propId={ele._id}
                        setIsEditable={setIsEditable}
                        entirePropData={ele}
                        accepted={accepted}
                        handleDownloadExcel={handleDownloadExcel}
                        generatePresentation={generatePresentation}
                        client={ele?.client?.name}
                        clientId={ele?.client?._id}
                        PR={PR}
                        setPR={setPR}
                        downloadAllowed={downloadAllowed}
                        setEditProposal={setEditProposal}
                        excelURL={excelURL}
                        setExcelURL={setExcelURL}
                        pptURL={pptURL}
                        setPptURL={setPptURL}
                      />
                    );
                  } else {
                    return (
                      <FileInput
                        data={elem}
                        isOpen={isOpen}
                        ind={ind}
                        length={ele.generatedProps?.length}
                        index={index}
                        setOk={setOk}
                        propId={ele._id}
                        setIsEditable={setIsEditable}
                        entirePropData={ele}
                        handleDownloadExcel={handleDownloadExcel}
                        generatePresentation={generatePresentation}
                        client={ele?.client?.name}
                        PR={PR}
                        setPR={setPR}
                        downloadAllowed={downloadAllowed}
                        excelURL={excelURL}
                        setExcelURL={setExcelURL}
                        pptURL={pptURL}
                        setPptURL={setPptURL}
                      />
                    );
                  }
                })}
              </div>
            );
          } else {
            return (
              <div className="fileList">
                {ele?.generatedProps.map((elem, indx) => {
                  return (
                    <FileInputWithHistoryView
                      toggleList={toggleList}
                      isOpen={isOpen}
                      ind={ind}
                      index={indx}
                      data={elem}
                      length={ele.generatedProps?.length}
                      setOk={setOk}
                      propId={ele._id}
                      entirePropData={ele}
                      setIsEditable={setIsEditable}
                      accepted={accepted}
                      handleDownloadExcel={handleDownloadExcel}
                      generatePresentation={generatePresentation}
                      client={ele?.client?.name}
                      clientId={ele?.client?._id}
                      PR={PR}
                      setPR={setPR}
                      downloadAllowed={downloadAllowed}
                      setEditProposal={setEditProposal}
                      excelURL={excelURL}
                      setExcelURL={setExcelURL}
                      pptURL={pptURL}
                      setPptURL={setPptURL}
                    />
                  );
                })}
              </div>
            );
          }
        })}
        {proposals?.length === 0 && (
          <div
            style={{
              display: "grid",
              placeItems: "center",
              height: "100%",
              width: "100%",
              color: "gray",
              fontWeight: "600",
              fontSize: "2rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <FaInbox /> No Proposals
            </div>
          </div>
        )}
      </div>
      <ModalCustom
        ok={ok}
        setOk={setOk}
        inventories={inventories}
        setInventories={setInventories}
        setSelectedInv={setSelectedInv}
        proposalId={proposalId}
        setFetchProp={setFetchProp}
        isEditable={isEditable}
        setPR={setPR}
        PR={PR}
        editProposal={editProposal}
      />
    </div>
  );
};
export default TabContent1;
